import ApplicationController from './application_controller'

// this controller works great with NestedAttributeDestroyableController to
// manage _destroy / remove() of listItems
//
export default class extends ApplicationController {

	static targets = [
		'list',
		'listItem',
		'listItemTemplate',
		'emptyListItemTemplate',
		'insertBeforeItem'
	]

	connect() {
		this.updateEmptyListItem()
	}	

	listItemTargetConnected(_element) {
		this.updateEmptyListItem()
	}

	listItemTargetDisconnected(_element) {
		this.updateEmptyListItem()
	}

	addNewItem() {
		const newItemElement = this.listItemTemplateTarget.content.cloneNode(true)
		if (this.hasInsertBeforeItemTarget) {
			this.insertBeforeItemTarget.parentNode.insertBefore(newItemElement, this.insertBeforeItemTarget)
		} else {
			this.listTarget.append(newItemElement)
		}
	}

	updateEmptyListItem() {
		const activeListItems = this.listItemTargets.filter((listItem) => !listItem.classList.contains('mark-to-destroy'))
		if (activeListItems.length == 0) {
			this.addEmptyListItem()
		} else {
			this.removeEmptyListItem()
		}
	}

	addEmptyListItem() {
		if (!this.hasEmptyListItemTemplateTarget) { return }

		const emptyListItemElement = this.emptyListItemTemplateTarget.content.cloneNode(true)
		this.listTarget.prepend(emptyListItemElement)
		this.activeEmptyListItem = this.listTarget.firstChild
	}

	removeEmptyListItem() {
		if (!this.activeEmptyListItem) { return }

		this.activeEmptyListItem.remove()
	}

}
